<template>
  <div class="d-flex justify-center align-center">
    <div
      v-for="(account, index) in accounts.slice(0, accountsToDisplay)"
      :key="account.id"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <UserAvatar
              class="account-item cursor-pointer"
              fontSize="10px"
              :size="`${avatarSize}px`"
              :class="{ 'ml-0': index === 0 }"
              :account="account"
            />
          </div>
        </template>
        {{ getFullName(account) }}
      </v-tooltip>
    </div>

    <v-menu
      v-if="moreAccounts.length"
      open-on-hover
      content-class="more-users-list"
    >
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          class="account-item more-items blue white--text d-flex justify-center align-center chip-over-chip font-weight-600 font-size-10 cursor-pointer"
          :style="{
            width: `${avatarSize}px`,
            height: `${avatarSize}px`,
            'border-radius': `${avatarSize / 2}px`,
          }"
        >
          +{{ moreAccounts.length }}
        </div>
      </template>

      <v-card
        class="ma-0 pa-0 blue-grey lighten-3 px-4 pt-4 pb-1 item-detail"
        dense
        elevation="2"
      >
        <p
          v-for="(account, index) in moreAccounts"
          class="ma-0 pa-0 label mb-3 blue-grey--text text--darken-2 font-weight-400"
          :key="`${account}${index}`"
        >
          {{ getFullName(account) }}
        </p>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import userMixin from '@/mixins/userMixin.vue'

import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'UsersAvatarList',

  mixins: [userMixin],

  components: { UserAvatar },

  props: {
    accounts: {
      type: Array,
      default: () => [],
    },

    accountsToDisplay: {
      type: Number,
      default: 4,
    },

    avatarSize: {
      type: Number,
      default: 32,
    },
  },

  computed: {
    moreAccounts() {
      return this.accounts?.slice(this.accountsToDisplay) ?? []
    },
  },
}
</script>

<style scoped lang="scss">
.account-item {
  margin-left: -6px;
  z-index: 1;
}
.more-items {
  z-index: 1;
  margin-top: 1px;
}
</style>
